import React, { useEffect, useState, createElement } from 'react';
import { Star, Check, ArrowRight, ShieldCheck, Clock, Award } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
// Images
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/7aJzguEJPkivQMEGogEA21/ChatGPT_Image_13_ene_2026,_11_36_37_p.m..png';
const BONUS_IMAGES = ['https://cdn.magicpatterns.com/uploads/oPkX2q2KjAu59vpaaV2ZJW/ChatGPT_Image_13_ene_2026,_11_36_04_p.m..png', 'https://cdn.magicpatterns.com/uploads/8c9SkFpJyh1F8Y4JRRpvdX/ChatGPT_Image_13_ene_2026,_11_35_50_p.m..png', 'https://cdn.magicpatterns.com/uploads/j7c9W22jwyQhKLL1y8zKQ8/ChatGPT_Image_13_ene_2026,_11_35_44_p.m..png', 'https://cdn.magicpatterns.com/uploads/neajRrdz1LTHvnx59H9Nkx/ChatGPT_Image_13_ene_2026,_11_35_30_p.m..png'];
const TESTIMONIALS = [{
  name: 'María González',
  age: '58 años',
  location: 'Buenos Aires',
  text: 'Pensé que nunca más iba a poder caminar sin dolor en las rodillas. Después de 3 semanas con el programa, volví a salir a caminar al parque con mis nietos. Es increíble cómo algo tan suave puede ser tan efectivo.',
  rating: 5
}, {
  name: 'Roberto Fernández',
  age: '62 años',
  location: 'Córdoba',
  text: 'El dolor de espalda no me dejaba dormir. Probé quiroprácticos, masajes, todo. Este método me enseñó a moverme diferente. Hoy duermo de corrido y me levanto sin rigidez.',
  rating: 5
}, {
  name: 'Ana Martínez',
  age: '54 años',
  location: 'Rosario',
  text: "Lo que más recuperé fue la confianza. Antes vivía con miedo a 'quedarme dura'. Ahora sé qué hacer si aparece una molestia y cómo aliviarla yo misma. Gracias por devolverme la libertad.",
  rating: 5
}, {
  name: 'Carlos López',
  age: '67 años',
  location: 'Mendoza',
  text: 'El médico ya me había dado fecha para la cirugía de cadera. Decidí probar esto como última opción. Cancelé la cirugía hace dos meses. No digo que soy un atleta, pero vivo mi vida normal y sin dolor.',
  rating: 5
}, {
  name: 'Patricia Ruiz',
  age: '51 años',
  location: 'La Plata',
  text: "Estaba tomando antiinflamatorios todos los días. Hoy hace 10 días que no tomo nada. Los ejercicios de 'Rutinas Express' son mi salvación cuando tengo poco tiempo.",
  rating: 5
}];
const PRICING_TIERS = [{
  id: 1,
  originalPrice: 49990,
  finalPrice: 19990,
  checkoutUrl: 'https://checkout.solucionstore.shop/cart/44907607982271:1',
  discount: 60,
  label: 'PLAN BÁSICO',
  includes: ['1 LIBRO - VIVIR SIN DOLOR (Producto Principal)', 'Bono 1: Primeros 7 Días Sin Miedo', 'Bono 2: Qué Hacer Cuando Aparece el Dolor', 'Bono 3: Errores Invisibles', 'Bono 4: Rutinas Express de 5 Minutos']
}, {
  id: 2,
  originalPrice: 49990,
  finalPrice: 26990,
  checkoutUrl: 'https://checkout.solucionstore.shop/cart/44907682693311:1',
  discount: 46,
  label: 'PLAN COMPLETO',
  popular: true,
  includes: ['1 LIBRO - VIVIR SIN DOLOR (Producto Principal)', 'Todos los 4 Bonos incluidos', '1 LIBRO - MINI-CURSO RODILLAS DE HIERRO']
}, {
  id: 3,
  originalPrice: 79990,
  finalPrice: 39990,
  checkoutUrl: 'https://checkout.solucionstore.shop/cart/44908601082047:1',
  discount: 50,
  label: 'PLAN PREMIUM',
  includes: ['1 LIBRO - VIVIR SIN DOLOR (Producto Principal)', 'Todos los 4 Bonos incluidos', '1 LIBRO - MINI-CURSO RODILLAS DE HIERRO', '1 LIBRO - Guía de Nutrición Antiinflamatoria']
}];
export function VivirSinDolorPage() {
  // Meta Pixel tracking - safer implementation
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Check if fbq already exists
    if ((window as any).fbq) return;
    // Initialize fbq function
    const fbq = function () {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, arguments);
      } else {
        ;
        (fbq as any).queue.push(arguments);
      }
    };
    (fbq as any).push = fbq;
    (fbq as any).loaded = true;
    (fbq as any).version = '2.0';
    (fbq as any).queue = [];
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Safely append to document
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Initialize pixel and track PageView
    ;
    (window as any).fbq('init', '2411207615977952');
    (window as any).fbq('track', 'PageView');
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#fafafa] font-sans text-gray-800" data-id="element-10">
      <PurchaseNotification data-id="element-11" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-teal-50 to-white pt-12 pb-16 px-4" data-id="element-12">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-13">
          <div className="order-2 md:order-1 space-y-8" data-id="element-14">
            <h1 className="text-4xl md:text-6xl font-extrabold text-teal-900 leading-tight" data-id="element-15">
              VIVIR <span className="text-orange-500" data-id="element-16">SIN DOLOR</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 font-medium leading-relaxed" data-id="element-17">
              Cómo miles de personas están recuperando movimiento, confianza y
              calidad de vida sin cirugías, sin impacto y sin miedo.
            </p>
            <button onClick={scrollToPurchase} className="w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105 flex items-center justify-center gap-2" data-id="element-18">
              QUIERO VIVIR SIN DOLOR <ArrowRight className="w-6 h-6" data-id="element-19" />
            </button>
          </div>
          <div className="order-1 md:order-2 flex justify-center" data-id="element-20">
            <img src={MAIN_IMAGE} alt="Vivir Sin Dolor Programa" className="w-full max-w-md rounded-xl shadow-2xl cursor-pointer hover:shadow-3xl transition-shadow duration-300" onClick={scrollToPurchase} data-id="element-21" />
          </div>
        </div>
      </header>

      {/* Sales Letter Content */}
      <main className="max-w-3xl mx-auto px-6 py-12" data-id="element-22">
        <div className="prose prose-lg prose-teal mx-auto text-gray-700 space-y-8" data-id="element-23">
          <p className="font-medium text-xl border-l-4 border-orange-500 pl-4 italic" data-id="element-24">
            Si cada mañana te levantás preguntándote qué parte del cuerpo va a
            doler hoy… si te movés con cuidado, con miedo, midiendo cada paso,
            cada giro, cada esfuerzo… esto es para vos.
          </p>

          <p data-id="element-25">
            Porque aunque te hayan dicho que es normal, aunque te hayan repetido
            que es la edad, aunque te hayan hecho creer que ya no hay mucho por
            hacer…
          </p>

          <p className="text-2xl font-bold text-center text-teal-900 py-4" data-id="element-26">
            no tiene que ser así.
          </p>

          <p data-id="element-27">
            El dolor no es una condena. No es algo que tengas que aceptar. Y
            mucho menos resignarte a vivir así el resto de tu vida.
          </p>

          <p data-id="element-28">
            La mayoría de las personas con dolor crónico no sufren porque su
            cuerpo esté "gastado" o "roto". Sufren porque nadie les enseñó a
            moverse de la forma correcta.
          </p>

          <p data-id="element-29">
            Tal vez probaste pastillas. Tal vez hiciste ejercicios. Tal vez
            descansaste más de la cuenta. Tal vez incluso te hablaron de
            cirugía.
          </p>

          <p className="font-bold" data-id="element-30">Y aun así… el dolor sigue ahí.</p>

          <p data-id="element-31">
            No porque seas débil. No porque hiciste algo mal. Sino porque todas
            esas soluciones atacan el síntoma, pero no la causa real.
          </p>

          <div className="bg-teal-50 p-8 rounded-xl border border-teal-100 my-8" data-id="element-32">
            <p className="text-xl font-bold text-teal-900 mb-4" data-id="element-33">
              El problema no es tu cuerpo. El problema es cómo lo estás usando
              hoy.
            </p>
            <p data-id="element-34">
              Imaginá una puerta vieja que chirría cada vez que la abrís. ¿La
              pateás? ¿La forzás? ¿La cambiás?
            </p>
            <p className="font-bold mt-4" data-id="element-35">No.</p>
            <p data-id="element-36">
              La alineás. La lubricás. La movés suavemente… hasta que vuelve a
              funcionar como antes.
            </p>
            <p className="font-bold mt-4 text-lg" data-id="element-37">
              Eso mismo necesita tu cuerpo.
            </p>
          </div>

          <p data-id="element-38">
            El dolor crónico no viene del movimiento. Viene del mal movimiento.
          </p>

          <p data-id="element-39">
            Viene de músculos que dejaron de activarse. De articulaciones
            rígidas. De años de compensaciones. De miedo acumulado en el cuerpo.
          </p>

          <p data-id="element-40">
            Y cuanto más miedo tenés de moverte, más rígido se vuelve tu cuerpo.
            Y cuanto más rígido se vuelve, más duele.
          </p>

          <p data-id="element-41">Es un círculo del que casi nadie te explica cómo salir.</p>

          <p className="text-2xl font-bold text-teal-800 mt-8" data-id="element-42">
            Pero existe una forma distinta.
          </p>

          <p data-id="element-43">Una forma sin impacto. Sin dolor. Sin cirugías. Sin miedo.</p>

          <p data-id="element-44">
            Una forma que ya ayudó a miles de personas a volver a caminar,
            levantarse, girar, agacharse y moverse con confianza.
          </p>

          <h2 className="text-4xl font-extrabold text-center text-orange-500 my-12" data-id="element-45">
            Se llama VIVIR SIN DOLOR.
          </h2>

          <p data-id="element-46">
            VIVIR SIN DOLOR no es una pastilla. No es una infiltración. No es
            una promesa vacía.
          </p>

          <p data-id="element-47">
            Es un programa de movimiento terapéutico, progresivo y sin impacto,
            diseñado especialmente para personas que quieren recuperar su cuerpo
            sin ponerlo en riesgo.
          </p>

          <ul className="space-y-4 my-8" data-id="element-48">
            <li className="flex items-center gap-3" data-id="element-49">
              <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-50" />
              <span className="font-bold text-lg" data-id="element-51">No fuerza.</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-52">
              <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-53" />
              <span className="font-bold text-lg" data-id="element-54">No exige.</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-55">
              <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-56" />
              <span className="font-bold text-lg" data-id="element-57">No lastima.</span>
            </li>
          </ul>

          <h3 className="text-3xl font-bold text-teal-900 text-center" data-id="element-58">
            Reeducar.
          </h3>

          <p data-id="element-59">
            A través de movimientos suaves y controlados, este método vuelve a
            activar músculos profundos, mejora la movilidad articular y devuelve
            estabilidad y confianza al cuerpo.
          </p>

          <p data-id="element-60">No se trata de hacer más esfuerzo. Se trata de moverse mejor.</p>

          <p data-id="element-61">
            Por eso funciona incluso en personas que llevan años con dolor.
            Porque empieza donde estás hoy, no donde "deberías estar".
          </p>

          <div className="my-12 text-center" data-id="element-62">
            <button onClick={scrollToPurchase} className="bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-10 rounded-full shadow-xl transform transition hover:scale-105 text-lg" data-id="element-63">
              SÍ, QUIERO RECUPERAR MI MOVIMIENTO
            </button>
          </div>

          <p className="text-xl font-medium text-teal-800" data-id="element-64">
            Cuando empezás, algo cambia.
          </p>

          <p data-id="element-65">
            Te movés sin miedo. Tu cuerpo se siente más estable. La rigidez
            disminuye. El dolor deja de dominar tus decisiones. Volvés a confiar
            en vos.
          </p>

          <p data-id="element-66">No de un día para el otro. Pero de verdad.</p>

          <p data-id="element-67">
            Este programa fue creado después de ver a demasiadas personas
            empujadas a cirugías innecesarias, resignadas al dolor y convencidas
            de que ya no había alternativa.
          </p>

          <p data-id="element-68">La alternativa existe. Y no es agresiva. Es inteligente.</p>

          <div className="bg-orange-50 p-8 rounded-xl border border-orange-200 my-8" data-id="element-69">
            <h4 className="text-xl font-bold text-orange-800 mb-4" data-id="element-70">
              ¿Es para vos?
            </h4>
            <p data-id="element-71">
              <strong data-id="element-72">VIVIR SIN DOLOR es para vos</strong> si hoy sentís dolor
              en rodillas, caderas, espalda, cuello u hombros… si querés evitar
              cirugías… si estás cansado de depender de pastillas… si querés
              volver a moverte con seguridad y libertad.
            </p>
            <p className="mt-4" data-id="element-73">
              <strong data-id="element-74">No es para vos</strong> si buscás una solución mágica sin
              hacer nada. No es para vos si no estás dispuesto a moverte de
              forma suave y consciente.
            </p>
          </div>

          <p data-id="element-75">
            Pero si estás listo para darle a tu cuerpo una oportunidad real…
          </p>

          <p className="text-2xl font-bold text-center" data-id="element-76">
            entonces este es tu momento.
          </p>

          <p data-id="element-77">
            Porque tu cuerpo todavía puede mejorar. Todavía puede adaptarse.
            Todavía puede responder.
          </p>

          <p data-id="element-78">
            No importa lo que te dijeron. No importa cuántos intentos fallidos
            tengas detrás.
          </p>

          <p className="font-bold text-lg" data-id="element-79">Hoy tenés dos opciones.</p>

          <p data-id="element-80">Seguir como estás, moviendo tu vida alrededor del dolor.</p>

          <p data-id="element-81">
            O empezar a recuperar tu movimiento, tu confianza y tu calidad de
            vida.
          </p>

          <p className="text-xl font-bold text-teal-700" data-id="element-82">
            VIVIR SIN DOLOR te muestra cómo hacerlo.
          </p>

          <p data-id="element-83">Sin impacto. Sin miedo. A tu ritmo.</p>
        </div>
      </main>

      {/* Bonuses Section */}
      <section className="bg-teal-900 py-16 px-4 text-white" data-id="element-84">
        <div className="max-w-6xl mx-auto" data-id="element-85">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4" data-id="element-86">
            Bonos Incluidos
          </h2>
          <p className="text-center text-orange-400 text-2xl font-bold mb-12 uppercase tracking-wider" data-id="element-87">
            ¡GRATIS SOLO POR HOY!
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-88">
            {BONUS_IMAGES.map((img, index) => <div key={index} className="relative group cursor-pointer transform transition hover:-translate-y-2" onClick={scrollToPurchase} data-id="element-89">
                <div className="absolute top-0 right-0 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10 shadow-md" data-id="element-90">
                  GRATIS HOY
                </div>
                <img src={img} alt={`Bono ${index + 1}`} className="w-full h-auto rounded-lg shadow-xl border-2 border-teal-700 group-hover:border-orange-500 transition-colors" data-id="element-91" />
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 px-4 bg-white" data-id="element-92">
        <div className="max-w-6xl mx-auto" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-94">
            Historias Reales de Recuperación
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-95">
            {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-gray-50 p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-96">
                <div className="flex gap-1 mb-4" data-id="element-97">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-98" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-99">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-100">
                  <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center text-teal-700 font-bold" data-id="element-101">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-102">
                    <p className="font-bold text-gray-900" data-id="element-103">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-104">
                      {testimonial.age} • {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="compra" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-teal-50" data-id="element-105">
        <div className="max-w-7xl mx-auto" data-id="element-106">
          <div className="text-center mb-12" data-id="element-107">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-108">
              Empezá Tu Recuperación Hoy
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-109">
              Elegí el plan que mejor se adapte a tus necesidades. Sin
              mensualidades. Un solo pago. Acceso de por vida.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto" data-id="element-110">
            {PRICING_TIERS.map(tier => <div key={tier.id} className={`bg-white p-8 rounded-3xl shadow-xl border-2 relative ${tier.popular ? 'border-orange-500 transform md:scale-105 pt-12' : 'border-teal-100'}`} data-id="element-111">
                {tier.popular && <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 w-full flex justify-center" data-id="element-112">
                    <span className="bg-orange-500 text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-113">
                      MÁS POPULAR
                    </span>
                  </div>}

                <div className="text-center mb-6" data-id="element-114">
                  <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-115">
                    {tier.label}
                  </h3>

                  <p className="text-gray-400 text-base font-medium line-through decoration-red-500 decoration-2 mb-2" data-id="element-116">
                    ${tier.originalPrice.toLocaleString('es-AR')}
                  </p>

                  <div className="flex items-baseline justify-center gap-1 mb-3" data-id="element-117">
                    <span className="text-5xl font-extrabold text-teal-600" data-id="element-118">
                      ${tier.finalPrice.toLocaleString('es-AR')}
                    </span>
                  </div>

                  <p className="text-green-600 font-bold bg-green-50 px-4 py-1 rounded-full inline-block" data-id="element-119">
                    Ahorrás {tier.discount}% HOY
                  </p>
                </div>

                <div className="space-y-3 text-sm text-gray-700 mb-6" data-id="element-120">
                  {tier.includes.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-121">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-122" />
                      <span data-id="element-123">{item}</span>
                    </div>)}
                </div>

                <a href={tier.checkoutUrl} className={`block w-full text-center font-bold py-4 px-6 rounded-xl shadow-lg transform transition hover:scale-[1.02] hover:shadow-2xl ${tier.popular ? 'bg-orange-500 hover:bg-orange-600 text-white text-lg' : 'bg-teal-600 hover:bg-teal-700 text-white'}`} data-id="element-124">
                  EMPEZÁ HOY
                </a>
              </div>)}
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-500 mt-12" data-id="element-125">
            <div className="flex items-center gap-2" data-id="element-126">
              <ShieldCheck className="w-5 h-5 text-teal-600" data-id="element-127" />
              <span data-id="element-128">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-129">
              <Clock className="w-5 h-5 text-teal-600" data-id="element-130" />
              <span data-id="element-131">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-132">
              <Award className="w-5 h-5 text-teal-600" data-id="element-133" />
              <span data-id="element-134">Garantía de Satisfacción</span>
            </div>
          </div>

          <div className="mt-12 text-center space-y-4" data-id="element-135">
            <p className="text-xl font-bold text-gray-800" data-id="element-136">
              👉 Empezá hoy. 👉 Volvé a moverte con libertad. 👉 Volvé a confiar
              en tu cuerpo.
            </p>
            <p className="text-2xl font-serif italic text-teal-800" data-id="element-137">
              VIVIR SIN DOLOR
            </p>
            <p className="text-gray-600" data-id="element-138">
              Tu cuerpo todavía está con vos. Solo necesita que tomes la
              decisión.
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-139">
        <p data-id="element-140">
          © {new Date().getFullYear()} Vivir Sin Dolor. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-141">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}